export default [
  {
    title: 'general.upravnik',
    icon: 'HomeIcon',
    route: 'e-manager',
    children: [
      {
        title: 'general.your_units',
        route: 'your-units'
      },
      {
        title: 'general.divider',
        route: 'card-traffic'
      },
      {
        title: 'general.open_items',
        route: 'open-items'
      },
      {
        title: 'general.funds',
        route: 'reserve-fund-funds'
      },
      {
        title: 'general.manager_documents',
        route: 'manager-documents'
      },
      {
        title: 'general.readings',
        route: 'readings',
        requiresHabitManager: true

      },
      {
        title: 'Dobavitelji',
        route: 'suppliers'
      },
      {
        title: 'general.bulletin_board',
        route: 'bulletin-board'
      },
      {
        title: 'general.notifications',
        route: 'notifications'
      },
      {
        title: 'general.agent_messages',
        route: 'agent_messages'
      },
      {
        title: 'general.reported_num_people_dogs',
        route: 'registered-number-of-people-and-dogs'
      },
      {
        title: 'general.meetings',
        route: 'meetings'
      }
    ],
    requiresAuth: true,
    requiresEmailConfirmation: true
  },
  {
    title: 'general.portal',
    icon: 'HomeIcon',
    children: [
      {
        title: 'general.news',
        route: 'news-list'
      },
      {
        title: 'Storitve',
        route: 'service-list',
        requiresAuth: true,
        requiresEmailConfirmation: true
      },
      {
        title: 'Trgovina',
        route: 'web-shop-items-list',
        requiresAuth: true,
        requiresEmailConfirmation: true
      },
      {
        title: 'general.real_estates',
        href: 'https://nepremicnine.esoseska.si'
      },
      {
        title: 'general.TRZNICA',
        route: 'ad-list'
      }
    ]
  },
  {
    title: 'general.kontakti',
    icon: 'HomeIcon',
    route: 'contacts'
  }
]
